import React, {useMemo, useState} from "react";
import DataTable from 'react-data-table-component';
import FilterComponent from "./FilterComponent";
import ApiFunctions from "../Api/ApiFunctions";
import SimpleModal from "../Modal/SimpleModal";
import {Link} from "react-router-dom";
const columns = [
    {
        name: 'Name',
        selector: row => row.firstname + " " + row.lastname,
    },
    {
        name: 'Telefonnummer',
        selector: row => row.phone
    },

    {
        name: 'E-Mail',
        selector: row => row.email,
    },
];

export default function Telefonliste() {
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [contactData, setContactData] = useState('');
    const [showModal, setShowModal] = useState(false);

    function mapData(data) {
        const loadedContacts = [];
        for (const contact of data) {
            loadedContacts.push({
                id: contact.no,
                firstname: contact.firstName,
                lastname: contact.lastName,
                email: contact.eMail,
                phone: contact.extension
            });
        }
        setContacts(loadedContacts);
    }

    const filteredItems = contacts.filter(item =>
        (item.firstname && item.firstname.toLowerCase().includes(filterText.toLowerCase()))
        || (item.lastname && item.lastname.toLowerCase().includes(filterText.toLowerCase()))
        || (item.email && item.email.toLowerCase().includes(filterText.toLowerCase()))
        || (item.phone && item.phone.includes(filterText.toLowerCase()))
    )   ;

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };
        return <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear}
                                filterText={filterText}/>;
    }, [filterText, resetPaginationToggle]);

    const handleOnCellClick =  (event) => {setContactData(<><p>Name: {event.firstname} {event.lastname}</p><p>Mail: <Link
        to={'mailto:' + event.email}>{event.email}</Link></p><p>Telefon: <Link to={'tel:' +  event.phone}>{event.phone}</Link></p></>) ;setShowModal(true)}

    return (
        <>
            <ApiFunctions url="api/telefonliste" mappingFunction={mapData} />
            <SimpleModal show={showModal} onHide={() => setShowModal(false)} content={{
                title: 'Kontakt aufnehmen',
                body: contactData
            }}/>
            <DataTable
                columns={columns}
                data={filteredItems}
                subHeader subHeaderComponent={subHeaderComponentMemo}
                onRowClicked={handleOnCellClick}
            />
        </>
    );

}